import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CourseSectionService } from '../../services/course-section.service';
import { ToastService } from 'src/app/core/toast.service';
import { CommonServicesForAllModules } from 'src/app/shared/common/service';
import { TABLE_FIELDS, Tables } from 'src/app/shared/enum/tables.enum';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { LoginService } from 'src/app/core/services/login.service';
@Component({
  selector: 'app-course-register',
  templateUrl: './course-register.component.html',
  styleUrls: ['./course-register.component.scss']
})
export class CourseRegisterComponent implements OnInit {

  courseId!: string;
  selectedCourse: any;
  registeredUsers: any[] = [];
  limit: number = 5;
  offset = 0;
  loading = false;
  allLoaded = false;
  loginDetails : any;
  selectedStatus: string = 'ALL';
  allUsers: any[] = [];
  RegisterUserTabCounts: any = {
    ALL: 0,
    APPROVED: 0,
    PENDING: 0,
    CANCELLED: 0,
    COMPLETED: 0,
  };


  constructor(
    private activeRoute: ActivatedRoute,
    private route: ActivatedRoute,
    private router: Router,
    private CourseSectionService: CourseSectionService,
    private spinner: NgxSpinnerService,
    private toast: ToastService,
    private commonService:CommonServicesForAllModules,
    private loginService: LoginService
  ) { }

  ngOnInit(): void {
    this.loadCourseAndUsers();
    this.loadRegisteredUsers();
    this.loadRegisterUserTabCounts();
    this.loginDetails = this.loginService.getLoginData()
  }

  loadCourseAndUsers(): void {
    this.activeRoute.params.subscribe((params) => {
      this.courseId = params['id'];

      this.commonService.GetById(Tables.Courses, this.courseId, TABLE_FIELDS.Course_Registered_Users).subscribe((data: any) => {
        this.selectedCourse = data;
        console.log('selectedCourse',this.selectedCourse)        
        
      });
    });
  }

  loadRegisteredUsers(): void {
    if (this.loading || this.allLoaded) return;

    this.loading = true;

  const statusToSend =
  this.selectedStatus ? this.selectedStatus.toUpperCase() : 'ALL';

    console.log('statusToSend',statusToSend)

    this.CourseSectionService.getCourseRegisteredUsers(this.courseId, this.limit, this.offset,statusToSend)
      .subscribe((users) => {

        if (!users || users.length === 0) {
          this.allLoaded = true;
        } else {
          this.registeredUsers = [...this.registeredUsers, ...users];
          console.log('registeredUsers',this.registeredUsers)
          this.offset += this.limit;

          //  If  users returned than the limit, no more data left
          if (users.length < this.limit) {
            this.allLoaded = true;
          }
        }

        this.loading = false;
      }, () => {
        this.loading = false;
      });
  }

 selectStatus(status: string) {
  this.selectedStatus = status;

  console.log('selectedStatus',this.selectedStatus)
  this.offset = 0;
  this.allLoaded = false;
  this.registeredUsers = [];

  this.loadRegisteredUsers();
}



loadRegisterUserTabCounts(): void {

  this.CourseSectionService.getRegisterUserTabCounts(this.courseId)
    .subscribe((res: any) => {
      console.log('res------loadRegisterUserTabCounts',res)
      this.RegisterUserTabCounts = {
        ALL: res?.data?.all?.aggregate?.count || 0,
        APPROVED: res?.data?.approved?.aggregate?.count || 0,
        PENDING: res?.data?.pending?.aggregate?.count || 0,
        CANCELLED: res?.data?.cancelled?.aggregate?.count || 0,
        COMPLETED: res?.data?.completed?.aggregate?.count || 0,
      };
      console.log('RegisterUserTabCounts',this.RegisterUserTabCounts)

    });
}


  onScroll(): void {
    this.loadRegisteredUsers();
  }

async updateStatus(Id: string, WebinarStatus?: string, status?: string ) {

 const updateData: any = {};

      if (WebinarStatus) {
      updateData.webinar_status = WebinarStatus;

       if (WebinarStatus === 'APPROVED') {
      updateData.status = 'APPROVED';
    }
    
    }

    if (status) {
      updateData.status = status;
    }


  try {
    await this.commonService.UpdateData(Tables.Course_Registered_Users, Id, updateData);

    this.toast.openSnackBar(`User ${status === 'CANCELLED' ? 'cancelled' : status === 'COMPLETED' ? 'Certificate issued ' : 'approved'} successfully`);

    // Reset pagination and reload users
    this.offset = 0;
    this.allLoaded = false;
    this.registeredUsers = [];
    this.loadRegisteredUsers();
    this.loadRegisterUserTabCounts();

  } catch (err) {
    console.error('Failed to update webinar status:', err);
    this.toast.openSnackBar('Failed to update webinar status');
  }
}


  prsentersConfig: SwiperConfigInterface = {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 1000,
      disableOnInteraction: false,
    },
    speed: 1000,
    spaceBetween: 10,
    effect: 'slide', 
  };

}



